<template>
  <div class="vd-gl-content">
    <!-- 工具栏 -->
    <a-row class="vd-toolbar">
      <a-col class="vd-bar">
        <a-form layout="inline">
          <a-form-item>
            <a-tooltip title="题集名称">
              <a-input
                class="vd-input-xs"
                v-model="search.name"
                placeholder="题集名称"
                allowClear
              />
            </a-tooltip>
          </a-form-item>
          <a-form-item>
            <a-tooltip title="题集名称">
              <a-select
                style="width: 156px"
                v-model="search.type"
                placeholder="请选择项目类型"
                allowClear
              >
                <a-select-option v-for="item in subList" :key="item.id">
                  {{ item.nickname }}
                </a-select-option>
              </a-select>
            </a-tooltip>
          </a-form-item>
          <a-form-item>
            <a-tooltip>
              <a-button type="primary" icon="search" @click="searchData">
              </a-button>
            </a-tooltip>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" icon="plus" @click="addGroup">
              新增题集
            </a-button>
          </a-form-item>
        </a-form>
      </a-col>
    </a-row>

    <a-table
      :pagination="pagination"
      :data-source="list"
      :loading="loading"
      row-key="id"
    >
      <a-table-column title="ID" data-index="id" />
      <a-table-column title="题集名称" data-index="name" />
      <a-table-column title="类型" data-index="category_name" />
      <a-table-column title="创建者" data-index="nickname" />
      <a-table-column title="操作" align="center">
        <template slot-scope="item">
          <a-tooltip title="上传题目">
            <a-icon class="common-icon" type="book" @click="bandExam(item)" />
          </a-tooltip>
          <a-tooltip title="关联QQ群">
            <a-icon
              class="common-icon"
              type="link"
              @click="bandQqGroup(item)"
            />
          </a-tooltip>
        </template>
      </a-table-column>
    </a-table>
    <!-- 新增修改题集 -->
    <a-modal
      :title="title"
      :visible="visible"
      @cancel="onCancel('visible')"
      @ok="onOk('visible')"
      cancel-text="取消"
      ok-text="确定"
    >
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        layout="horizontal"
      >
        <a-form-model-item label="名称" prop="name">
          <a-input
            class="vd-input-s"
            v-model="form.name"
            placeholder="请输入题集名称"
            allowClear
          />
        </a-form-model-item>
        <a-form-model-item label="题集类型" prop="type">
          <a-select
            style="width: 156px"
            v-model="form.type"
            placeholder="请选择项目类型"
            allowClear
          >
            <a-select-option v-for="item in subList" :key="item.id">
              {{ item.nickname }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 上传题目1 -->
    <a-modal
      :title="title"
      :visible="upVisible"
      :width="1200"
      @cancel="onCancel('upVisible')"
      @ok="onOk('upVisible')"
      cancel-text="取消"
      ok-text="确定"
    >
      <a-row class="vd-toolbar">
        <a-col class="vd-bar">
          <input id="file" type="file" name="file" accept=".xls,.xlsx,.csv" />

          <a-button type="primary" @click="preview">预览</a-button>
          <a-button style="margin-left: 8px" @click="downloadTmp">
            下载模版
          </a-button>
        </a-col>
      </a-row>

      <a-table row-key="index" :data-source="examList" size="small">
        <a-table-column title="索引" data-index="index" />
        <a-table-column title="题目" data-index="title" />
        <a-table-column title="答案A" data-index="a" />
        <a-table-column title="答案B" data-index="b" />
        <a-table-column title="答案C" data-index="c" />
        <a-table-column title="答案D" data-index="d" />
        <a-table-column title="正确答案" data-index="answer" />
        <a-table-column title="解析" data-index="analysis" />
      </a-table>
    </a-modal>

    <!-- 绑定QQ群 -->
    <a-modal
      :title="title"
      :visible="qqVisible"
      @cancel="onCancel('qqVisible')"
      :footer="false"
      :width="1000"
    >
      <a-row class="vd-toolbar">
        <a-col class="vd-bar">
          <a-input
            class="vd-input-s"
            v-model="inputQqGroup"
            placeholder="请输入要绑定数据的群"
          />
          <a-button
            style="margin-left: 16px"
            type="primary"
            @click="bandQq"
            :disabled="$HelperUtil.isEmpty(inputQqGroup)"
          >
            绑定
          </a-button>
          <a-divider type="vertical" />
          <a-icon type="redo" class="common-icon" @click="getBandQQgroupList" />
        </a-col>
      </a-row>
      <a-table row-key="group" :data-source="qqList" size="small">
        <a-table-column title="群号" data-index="group" align="center" />
        <a-table-column title="绑定者" data-index="nickname" align="center" />
        <a-table-column title="是否开启答题" data-index="status" align="center">
          <template slot-scope="item, record">
            <a-tag :color="item == 2 ? '#87d068' : '#f50'">
              {{ item == 2 ? '已开启' : '未开启' }}
            </a-tag>
            <a-tag :color="item == 2 ? '#87d068' : '#f50'">
              进度 {{ record.index }} / {{ totalExam }}
            </a-tag>
          </template>
        </a-table-column>
        <a-table-column title="绑定时间" data-index="add_time" align="center">
          <template slot-scope="item">
            {{ $FormatUtil.timestamp2date(item) }}
          </template>
        </a-table-column>

        <a-table-column title="间隔" data-index="interval" align="center" />

        <a-table-column title="操作" align="center">
          <template slot-scope="item">
            <a-tag @click="removeBand(item.group, item.pid)">解除绑定</a-tag>
            <a-popconfirm
              placement="top"
              ok-text="修改"
              cancel-text="取消"
              @confirm="setInterval(item.group, item.pid, interval)"
            >
              <template slot="title">
                <p>设置时间间隔:</p>
                <a-input-number
                  v-model="interval"
                  size="small"
                  :max="120"
                  :min="20"
                />
              </template>
              <a-tag>设置间隔 </a-tag>
            </a-popconfirm>
            <a-tag @click="stopTest(item.group, item.pid)">终止答题</a-tag>
          </template>
        </a-table-column>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import { get_sub } from '@/api'
import {
  modify_exam_group,
  get_exam_group,
  modify_exam,
  get_exam,
  modify_band_exam,
  get_band_list,
  remove_band_exam,
  set_exam_interval,
  redo_test,
} from '@/api/qq'
import XLSX from 'xlsx'
export default {
  name: 'Exercise',
  data() {
    return {
      search: {
        name: undefined,
        type: undefined,
      },
      title: '',
      loading: false,
      visible: false,
      upVisible: false,
      qqVisible: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      rules: {
        name: [{ required: true, message: '请输入题集名称', trigger: 'blur' }],
        type: [{ required: true, message: '请选择题集类型', trigger: 'blur' }],
      },
      list: [],
      examGroupId: [],
      subList: [],
      examList: [],
      qqList: [],
      form: {
        name: undefined,
        type: undefined,
      },
      formExamId: undefined,
      inputQqGroup: undefined,
      bandExamId: undefined,
      totalExam: 0,
      interval: 30,
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        hideOnSinglePage: true,
        showTotal: (total) => `总共 ${total} 条`,
        onChange: (page) => {
          this.pagination.current = page
          this.getData()
        },
      },
    }
  },
  created() {
    get_sub('item_type').then((res) => {
      if (res.code === 1) {
        this.subList = res.list
      }
    })
    this.getData()
  },
  methods: {
    bandExam(item) {
      this.examGroupId = item.id
      get_exam({ id: this.examGroupId }).then((res) => {
        if (res.code === 1) {
          this.examList = res.list
        }
      })
      this.upVisible = true
      this.title = `题集《${item.name}》上传题目`
    },
    bandQqGroup(item) {
      this.qqVisible = true
      this.bandExamId = item.id
      this.title = `题集《${item.name}》绑定QQ群`
      this.totalExam = item.total
      this.getBandQQgroupList()
    },
    addGroup() {
      this.visible = true
      this.title = '新增题集'
    },
    onCancel(type) {
      switch (type) {
        case 'visible':
          this.visible = false
          this.form.name = undefined
          this.form.type = undefined
          break
        case 'upVisible':
          this.upVisible = false
          this.examGroupId = undefined
          this.examList = []
          break
        case 'qqVisible':
          this.qqVisible = false
          this.qqList = []
          this.totalExam = 0
          this.interval = 30
          break
        default:
          console.log('未知状态')
          break
      }
      this.title = false
    },
    onOk(type) {
      if (type === 'visible') {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            modify_exam_group({
              name: this.form.name,
              type: this.form.type,
            }).then((res) => {
              if (res.code === 1) {
                this.$message.success(res.msg)
                this.getData()
                this.onCancel('visible')
              } else {
                this.$message.warning(res.msg)
              }
            })
          }
        })
      } else if (type === 'upVisible') {
        // 获取文件流
        let file = document.getElementById('file').files[0]
        if (file === undefined) {
          this.$message.warning('请选择上传excel')
          return false
        }
        this.$HelperUtil.readExcel(file).then((res) => {
          this.examList = res
          // 更新数据
          modify_exam({
            id: this.examGroupId,
            data: this.examList,
          }).then((res) => {
            if (res.code === 1) {
              this.upVisible = !this.upVisible
              this.$message.success(res.msg)
            }
          })
        })
      } else if (type === 'qqvisible') {
        console.log(11)
      } else {
        console.log('未知状态')
      }
    },
    getData() {
      get_exam_group({
        current: this.pagination.current,
        pageSize: this.pagination.pageSize,
        name: this.search.name,
        type: this.search.type,
      }).then((res) => {
        if (res.code === 1) {
          this.list = res.list
          this.pagination.total = res.total
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    searchData() {
      this.getData()
    },
    downloadTmp() {
      const fields = [
        {
          index: '自增id',
          title: '举例',
          a: '答案A',
          b: '答案B',
          c: '答案C',
          d: '答案D',
          answer: '正确答案',
          analysis: '解析',
        },
      ]
      const ws = XLSX.utils.json_to_sheet(fields)
      let workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, ws, 'data drip')
      XLSX.writeFile(workbook, 'qq_exam_tmp.xlsx', {
        type: 'base64',
        bookType: 'xlsx',
      })
    },
    preview() {
      // 获取文件流
      let file = document.getElementById('file').files[0]
      if (file === undefined) {
        this.$message.warning('请选择上传excel')
        return false
      }
      this.$HelperUtil.readExcel(file).then((res) => {
        this.examList = res
      })
    },
    // 获取绑定列表
    getBandQQgroupList() {
      this.qqList = []
      get_band_list({
        id: this.bandExamId,
      }).then((res) => {
        if (res.code === 1) {
          this.qqList = res.list
        }
      })
    },
    // 绑定 考试
    bandQq() {
      modify_band_exam({
        id: this.bandExamId,
        group: this.inputQqGroup,
      }).then((res) => {
        if (res.code === 1) {
          this.$message.success({ content: res.msg, key: 'band' })
          this.getBandQQgroupList()
        } else {
          this.$message.warning({ content: res.msg, key: 'band' })
        }
      })
    },
    // 解除绑定考试
    removeBand(group, pid) {
      remove_band_exam({ group, pid }).then((res) => {
        if (res.code === 1) {
          this.$message.success({ content: res.msg, key: 'band' })
          this.getBandQQgroupList()
        } else {
          this.$message.warning({ content: res.msg, key: 'band' })
        }
      })
    },
    stopTest(group, pid) {
      redo_test({ group, pid }).then((res) => {
        if (res.code === 1) {
          this.$message.success({ content: res.msg, key: 'redo_test' })
          this.getBandQQgroupList()
        } else {
          this.$message.warning({ content: res.msg, key: 'redo_test' })
        }
      })
    },
    setInterval(group, pid, interval) {
      set_exam_interval({
        group,
        pid,
        interval,
      }).then((res) => {
        if (res.code === 1) {
          this.getBandQQgroupList()
          this.$message.success(res.msg)
        }
      })
    },
  },
}
</script>

<style></style>
